// extracted by mini-css-extract-plugin
module.exports = {"title":"TrainingKDDI_title_1G-7F","video":"TrainingKDDI_video_1y04D","note":"TrainingKDDI_note_3VEHB"};